<template>
  <div id="shelves">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        书籍阅读列表
        <el-button type="primary" @click="exportToExcel()" style="margin-left:20px;" class="el-icon-s-marketing"> 导出excel </el-button>
      </el-breadcrumb-item>
    </el-breadcrumb>
      <el-card class="box-card">
        <el-form ref="form" :model="searchForm" label-width="80px" :inline="true" size="small" class="admin_from">
        </el-form>
        <el-table size="small" :data="tableData" border style="width: 100%">
            <el-table-column type="index" label="书籍ID" width="100">
                  <template slot-scope="scope">
                      {{ scope.row.anid }}
                  </template>
            </el-table-column>
            <el-table-column label="封面" width="200">
                <template slot-scope="scope">
                    <img :src="scope.row.coverpic" width="30" height="30" alt="">
                </template>
            </el-table-column>
            <el-table-column  label="书名" width="300">
                  <template slot-scope="scope">
                    {{scope.row.title}}
                  </template>
            </el-table-column>
            <el-table-column  label="阅读总数排名">
                <template slot-scope="scope">
                    {{scope.row.count}}
                </template>
            </el-table-column>
        </el-table>
        <div class="el-pagination">
            <el-pagination
                    background
                    @size-change="changeSize"
                    @current-change="changeCurrent"
                    :current-page="params.pagenum"
                    :page-sizes="[10, 20, 30, 40]"
                    :page-size="params.pagesize"
                    :total="params.totals"
                    :layout="this.$store.state.paginationLayout">
            </el-pagination>
        </div>
    </el-card>
  </div>
</template>  
<script>
export default {
  name: "shelves",
  data(){
      return {
        params:{
          page_num:1,
          page_size:10,
          totals:0,
        },
        dataForm:{
          coverpic: '',
          title: '',
          anid:'',
        },
        tableData:[],
        exportList:[],
        fromTitle: '',
        visible:false,
        id:'',
      };
  },
  created(){
    this.getList();
  },
  methods:{
    getList(){
      let data = {
        page:this.params.page_num,
        page_size:this.params.page_size
      };
      this.$axios.post('admin/shelves/index',data).then(res => {
          this.params.totals = parseInt(res.data.count);
          this.tableData = res.data.list;
      });
    },
    //导出数据
    exportToExcel(){
      this.$axios.post("admin/shelves/index").then((val) =>{
            this.exportList = val.data.excel
            require.ensure([],()=>{
                const{
                    export_json_to_excel
                } = require('../../excel/Export2Excel');
                const tHeader = ['书籍ID','书籍名称','阅读排名'];
                const filterVal  = ['anid','title','count'];
                const list = this.exportList;
                const data = this.formatJson(filterVal,list);
                export_json_to_excel(tHeader,data,'书籍阅读_excel');
            })
      });
    },
    formatJson(filterVal,jsonData){
        return jsonData.map(v => filterVal.map(j => v[j]));
    },
    changeSize(val){
      this.params.page_size = val;
      this.getList();
    },
    changeCurrent(val) {
      this.params.page_num = val;
      this.getList();
    },
  }
}
</script>
